import React from 'react';
import { useSelector } from 'react-redux';
import { intlModule } from '@chedri/base';
import Modal from 'components/Modal';

export default function ModalFlyerAlarmOptions({ show, onHide, children }) {
  const messages = useSelector(intlModule.selectors.getMessages);

  return (
    <Modal show={show} onHide={onHide} bsSize="lg" className="full-width">
      <Modal.Header closeButton>
        <Modal.Title>FlyerAlarm options</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
